import React from 'react';
import { Link } from 'react-router-dom';
import HomeButton from './common/HomeButton';

const PartyNotFound = () => {
  return (
    <div className='onboarding-container'>
      <HomeButton />
      <div className='onboarding-card'>
        <h1>Party not found!</h1>
        <Link to='/create'>Click here to create one</Link>
      </div>
    </div>
  );
};

export default PartyNotFound;
